module.exports = __webpack_public_path__ + "img/apple.d6952f71.svg";